import { render, staticRenderFns } from "./m-edit-css-property.vue?vue&type=template&id=e23f948c&scoped=true&"
import script from "./m-edit-css-property.vue?vue&type=script&lang=js&"
export * from "./m-edit-css-property.vue?vue&type=script&lang=js&"
import style0 from "./m-edit-css-property.vue?vue&type=style&index=0&id=e23f948c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23f948c",
  null
  
)

export default component.exports